import Tabs from '@/components/Tabs';
import { FORM_TABS, type FormTabType } from '@/features/agent/form/constants';

interface Props {
  currentTab: FormTabType;
  onTabChange: (tab: FormTabType) => void;
  className?: string;
}

export default function FormTabs({ currentTab, onTabChange, className }: Props) {
  return (
    <Tabs
      items={FORM_TABS.map((tab) => ({
        ...tab,
        onClick: () => onTabChange(tab.id),
        current: currentTab === tab.id,
      }))}
      className={className}
    />
  );
}
